import { addLog } from 'assets/components/feedback/Feedback';
import ModalForm from 'assets/components/form/modalForm/ModalForm';
import ThemeModalFormDefault from 'assets/components/form/modalForm/themes/Theme.ModalForm.Default';
import FileInput from 'assets/components/inputs/file/FileInput';
import ThemeFileInputDropzone from 'assets/components/inputs/file/themes/Theme.FileInput.Dropzone';
import ErrorWrapper from 'assets/components/inputs/wrappers/ErrorWrapper';
import FormWrapper from 'assets/components/inputs/wrappers/FormWrapper';
import { getLocales } from 'assets/locales/Locale';
import Theme from 'assets/themes/Theme.Common';
import MimeType from 'assets/utils/file/mimeType/MimeType';
import { HttpStatus } from 'config/Api.Config';
import { compact, first } from 'lodash';
import lossCodeImportApi from 'models/claims/lossCode/import/Api.LossCode.Import';
import LossCodeSection from 'models/enums/LossCodeSection';
import React, { useState } from 'react';
import { useLossCodeProvider } from '../LossCode.Hooks';

type ImportFile = {
  file: Hooks.Input.File.Info;
};

const LossCodeImport: React.FC = () => {
  const { lang } = getLocales();
  const { pageRouter, listApi } = useLossCodeProvider();
  const [importError, setImportError] = useState<string>();

  const columns = [
    lang.code,
    lang.descriptionEnglish,
    lang.descriptionFrench,
    `${lang.lossCodeSection} (${[LossCodeSection.part, LossCodeSection.labour, LossCodeSection.other].join(', ')})`,
    lang.notes,
    `${lang.disabled} (TRUE/FALSE)`,
    `${lang.internalOnly} (TRUE/FALSE)`,
    lang.lossCodeImportCategoriesColumn,
  ];

  return (
    <ModalForm<ImportFile>
      subcomponents={ThemeModalFormDefault}
      title={lang.lossCodesImportExcel}
      onCancel={pageRouter.updateParams}
      onSubmit={async ({ file }) => {
        setImportError(undefined);
        const response = await lossCodeImportApi({ file: file?.original });

        if (response.status !== HttpStatus.ok) {
          setImportError(response.message ?? lang.importError);
          addLog({ error: lang.importError });
          return;
        }

        addLog({
          success: `${lang.importSuccess} ${lang.created}: ${response.payload?.createdCount ?? 0}, ${lang.updated}: ${
            response.payload?.updatedCount ?? 0
          }`,
        });
        listApi.execute((body) => body);
        pageRouter.updateParams();
      }}
      validation={(data, errors) => {
        if (!data?.file) errors.file = { _objectError: lang.mustNotBeEmpty };
      }}
      render={({ form }) => (
        <FormWrapper>
          <div style={{ fontSize: Theme.FontSize.S }}>
            <p>{lang.lossCodeImportColumnsInfo}</p>
            <ol type="A">
              {columns.map((column) => (
                <li key={column}>{column}</li>
              ))}
            </ol>
            <p>{lang.lossCodeImportUpdateInfo}</p>
          </div>
          <FileInput
            name="file"
            allowedMimeTypes={[MimeType.appMS_EXCEL, MimeType.appOPEN_XML_SHEET]}
            label={lang.lossCodesImportExcel}
            fileLimit={1}
            value={compact([form.data?.file])}
            error={form.errors.file?._objectError}
            onChange={({ file }) => {
              setImportError(undefined);
              form.update({ file: first(file) });
            }}
            class={ThemeFileInputDropzone}
          />
          {importError && <ErrorWrapper children={importError} />}
        </FormWrapper>
      )}
    />
  );
};

export default LossCodeImport;
